(function () {
  var MAX = 4;
  var labels = window.skCompareLabels || {};
  var allProducts = window.skAllProducts || [];
  var products = (window.skCompareInit || []).map(function (handle) { return allProducts.find(function (p) { return p.handle === handle; }); }).filter(Boolean).slice(0, MAX);

  var ROWS = [
    { key: 'price', label: labels.price || 'Hinta', price: true },
    { key: 'speed', label: labels.speed || 'Huippunopeus' },
    { key: 'range', label: labels.range || 'Toimintamatka' },
    { key: 'power', label: labels.power || 'Moottorin teho' },
    { key: 'weight', label: labels.weight || 'Paino' },
    { key: 'tires', label: labels.tires || 'Renkaat' },
    { key: 'brakes', label: labels.brakes || 'Jarrut' },
    { key: 'waterproof', label: labels.waterproof || 'IP-luokitus' },
    { key: 'trafficLegal', label: labels.trafficLegal || 'Tieliikennekelp.', bool: true },
    { key: 'foldable', label: labels.foldable || 'Taituva', bool: true }
  ];

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(value) {
    return value > 0 ? new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' }).format(value) : '–';
  }

  function bestVal(row) {
    if (!row.price) return null;
    var vals = products.map(function (p) { return Number(p.price); }).filter(function (v) { return v > 0; });
    return vals.length > 1 ? Math.min.apply(null, vals) : null;
  }

  function fmt(val, row) {
    return row.price ? money(val) : escapeHtml(val || '–');
  }

  function render() {
    var el = document.getElementById('sk-cptool-table');
    if (!el) return;
    var showAdd = products.length < MAX;
    var h = '<div class="sk-cpt">';

    
    h += '<div class="sk-cpt-row sk-cpt-cards"><div class="sk-cpt-lbl-cell"></div>';
    products.forEach(function (p, i) {
      var imgH = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name) + '" loading="lazy">'
        : '<span>' + escapeHtml(labels.no_image) + '</span>';
      var priceStr = money(p.price);
      h += '<div class="sk-cpt-col" data-col="' + i + '">'
        + '<div class="sk-cpt-img sk-ph">' + imgH + '</div>'
        + '<div class="sk-cpt-meta"><span class="sk-brandtag">' + escapeHtml(p.brand.toUpperCase()) + '</span>'
        + '<strong class="sk-cpt-name">' + escapeHtml(p.name) + '</strong></div>'
        + '<div class="sk-cpt-price">' + priceStr + '</div>';
      if (p.variantId) {
        h += '<button class="sk-btn sk-btn--primary sk-cpt-buy" data-variant="' + escapeHtml(p.variantId) + '">' + escapeHtml(labels.add_cart) + '</button>';
      } else {
        h += '<a class="sk-btn sk-btn--primary sk-cpt-buy" href="' + escapeHtml(p.url) + '">' + escapeHtml(labels.view_product) + '</a>';
      }
      h += '<button class="sk-btn sk-cpt-swap" data-col="' + i + '">' + escapeHtml(labels.swap) + '</button>'
        + '</div>';
    });
    if (showAdd) {
      h += '<div class="sk-cpt-col sk-cpt-add-col">'
        + '<button class="sk-cpt-add-btn" id="sk-cpt-add">'
        + '<span class="sk-cpt-plus">+</span>' + escapeHtml(labels.add_compare)
        + '</button></div>';
    }
    h += '</div>';

    
    ROWS.filter(function (row) { return row.key !== 'foldable' || products.some(function (p) { return typeof p.foldable === 'boolean'; }); }).forEach(function (row) {
      var best = bestVal(row);
      h += '<div class="sk-cpt-row"><div class="sk-cpt-lbl-cell"><span class="sk-cpt-lbl">' + escapeHtml(row.label) + '</span></div>';
      products.forEach(function (p, i) {
        var raw = p[row.key];
        var n = row.price ? Number(raw) : null;
        var isBest = best !== null && n === best && n > 0;
        var cls = 'sk-cpt-cell' + (isBest ? ' sk-cpt-best' : '');
        var txt;
        if (row.bool) {
          txt = raw === true ? '<span class="sk-cpt-yes">✓ ' + escapeHtml(labels.yes) + '</span>'
            : raw === false ? '<span class="sk-cpt-no">✗ ' + escapeHtml(labels.no) + '</span>'
            : escapeHtml(labels.unknown);
        } else {
          txt = fmt(raw, row);
        }
        h += '<div class="' + cls + '" data-col="' + i + '">' + txt + '</div>';
      });
      if (showAdd) h += '<div class="sk-cpt-cell sk-cpt-empty"></div>';
      h += '</div>';
    });

    
    h += '<div class="sk-cpt-row sk-cpt-rm-row"><div class="sk-cpt-lbl-cell"></div>';
    products.forEach(function (_, i) {
      h += '<div class="sk-cpt-cell"><button class="sk-btn sk-btn--ghost sk-cpt-rm" data-col="' + i + '">' + escapeHtml(labels.remove) + '</button></div>';
    });
    if (showAdd) h += '<div class="sk-cpt-cell sk-cpt-empty"></div>';
    h += '</div></div>';

    el.innerHTML = h;
    bind(el);
  }

  function bind(el) {
    el.querySelectorAll('.sk-cpt-rm').forEach(function (b) {
      b.addEventListener('click', function () {
        products.splice(+b.dataset.col, 1);
        render();
      });
    });
    var addBtn = el.querySelector('#sk-cpt-add');
    if (addBtn) addBtn.addEventListener('click', function () { openPicker(null); });
    el.querySelectorAll('.sk-cpt-swap').forEach(function (b) {
      b.addEventListener('click', function () { openPicker(+b.dataset.col); });
    });
    el.querySelectorAll('.sk-cpt-buy[data-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: b.dataset.variant, quantity: 1 })
        }).then(function (r) {
          if (r.ok) {
            b.textContent = '✓ ' + labels.added;
            setTimeout(function () { b.disabled = false; b.textContent = labels.add_cart; }, 2500);
          } else { b.disabled = false; b.textContent = labels.add_cart; }
        }).catch(function () { b.disabled = false; b.textContent = labels.add_cart; });
      });
    });
  }

  
  var pickerCol = null;

  function openPicker(col) {
    pickerCol = col;
    var t = document.getElementById('sk-cpicker-title');
    var s = document.getElementById('sk-cpicker-search');
    var modal = document.getElementById('sk-cpicker');
    if (t) t.textContent = col === null ? labels.add_compare : labels.change_model;
    if (s) s.value = '';
    showResults(allProducts.slice(0, 10));
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    setTimeout(function () { if (s) s.focus(); }, 60);
  }

  function closePicker() {
    var modal = document.getElementById('sk-cpicker');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function showResults(list) {
    var el = document.getElementById('sk-cpicker-results');
    if (!el) return;
    if (!list.length) {
      el.innerHTML = '<span class="sk-cpicker-empty">' + escapeHtml(labels.no_results) + '</span>';
      return;
    }
    el.innerHTML = list.map(function (p) {
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name) + '" loading="lazy">'
        : '<div class="sk-cpicker-no-img"></div>';
      var price = money(p.price);
      return '<button class="sk-cpicker-result" data-handle="' + escapeHtml(p.handle) + '">'
        + img
        + '<div class="sk-cpicker-info">'
        + '<span class="sk-cpicker-vendor">' + escapeHtml(p.brand) + '</span>'
        + '<span class="sk-cpicker-pname">' + escapeHtml(p.name) + '</span>'
        + '<span class="sk-cpicker-price">' + price + '</span>'
        + '</div></button>';
    }).join('');
    el.querySelectorAll('.sk-cpicker-result').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = allProducts.find(function (x) { return x.handle === b.dataset.handle; });
        if (!p) return;
        if (pickerCol === null) { if (products.length < MAX) products.push(p); }
        else products[pickerCol] = p;
        render();
        closePicker();
      });
    });
  }

  
  document.getElementById('sk-cpicker-close') && document.getElementById('sk-cpicker-close').addEventListener('click', closePicker);
  document.getElementById('sk-cpicker') && document.getElementById('sk-cpicker').addEventListener('click', function (e) {
    if (e.target.id === 'sk-cpicker') closePicker();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePicker();
  });

  
  var searchTimer;
  document.getElementById('sk-cpicker-search') && document.getElementById('sk-cpicker-search').addEventListener('input', function (e) {
    clearTimeout(searchTimer);
    var q = e.target.value.trim().toLowerCase();
    searchTimer = setTimeout(function () {
      if (!q) { showResults(allProducts.slice(0, 10)); return; }
      var filtered = allProducts.filter(function (p) {
        return p.name.toLowerCase().indexOf(q) !== -1 || p.brand.toLowerCase().indexOf(q) !== -1;
      }).slice(0, 10);
      showResults(filtered);
    }, 200);
  });

  
  var urlHandles = new URLSearchParams(location.search).get('compare');
  if (urlHandles) {
    var handles = urlHandles.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, MAX);
    var urlProds = handles.map(function (h) { return allProducts.find(function (p) { return p.handle === h; }); }).filter(Boolean);
    if (urlProds.length) products = urlProds;
  }

  
  if (products.length === 0 && allProducts.length > 0) {
    var defHandles = (window.skCompareDefaultHandles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (defHandles.length > 0) {
      products = defHandles.map(function (h) {
        return allProducts.find(function (p) { return p.handle === h; });
      }).filter(Boolean).slice(0, MAX);
    }
    
    if (products.length === 0) {
      var g2 = allProducts.find(function (p) {
        return p.brand.toLowerCase().indexOf('kukirin') !== -1 && p.name.toLowerCase().indexOf('g2') !== -1;
      });
      var xiaomi = allProducts.find(function (p) {
        return p.brand.toLowerCase().indexOf('xiaomi') !== -1;
      });
      var segway = allProducts.find(function (p) {
        return p.brand.toLowerCase().indexOf('segway') !== -1 || p.brand.toLowerCase().indexOf('ninebot') !== -1;
      });
      products = [g2, xiaomi, segway].filter(Boolean).slice(0, MAX);
    }
  }

  render();
})();
